/* eslint-disable max-len */
import generateCrudEndpoints from '@packages/toolbox/dist/utils/endpoint-generator';

import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

export const integrationsUrl = `${SERVER_API}/integrations`;

const generateIntegrationEndpoints = (url: string) => ({
  // Получение привязанных интеграций к специфичному объекту
  // (например маршруту, профилю или формуляру проекта)
  GET_CONFIGS(specificId: number): IEndpointData {
    return {
      method: 'GET',
      url: `${integrationsUrl}/${url}/${specificId.toString()}/configs`,
    };
  },
  // Получение привязанных интеграций к специфичному объекту
  // (например маршруту, профилю или формуляру проекта)
  //  сокращенная версия
  GET_CONFIGS_BRIEF(specificId: number): IEndpointData {
    return {
      method: 'GET',
      url: `${integrationsUrl}/${url}/${specificId.toString()}/configs-brieft`,
    };
  },
  // Создание новой конфигурации для привязки интеграции к специфичному объекту (например маршруту).
  // Привязка создаётся "за раз", с привязкой всех обязательных для работы интеграции полей
  CREATE(integrationId: number, specificId: number): IEndpointData {
    return {
      method: 'POST',
      url: `${integrationsUrl}/${integrationId.toString()}/${url}/${specificId.toString()}/configs`,
    };
  },
  // Обновление информации о привязке интеграции к специфичному объекту (например маршруту)
  UPDATE(integrationId: number, specificId: number, configId: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${integrationsUrl}/${integrationId.toString()}/${url}/${specificId.toString()}/configs/${configId.toString()}`,
    };
  },
  // Удаление конфигурации для привязки интеграции к специфичному объекту (например маршруту)
  DELETE(integrationId: number, specificId: number, configId: number): IEndpointData {
    return {
      method: 'DELETE',
      url: `${integrationsUrl}/${integrationId.toString()}/${url}/${specificId.toString()}/configs/${configId.toString()}`,
    };
  },
  // Привязка поля к интеграции.
  // Привязка подразумевает передачу значения из поля данных интеграции в поле секции маршрута
  BIND(integrationId: number, specificId: number, configId: number): IEndpointData {
    return {
      method: 'POST',
      url: `${integrationsUrl}/${integrationId.toString()}/${url}/${specificId.toString()}/configs/${configId.toString()}/bind`,
    };
  },
  // Снимает привязку поля к интеграции
  UNBIND(
    integrationId: number,
    specificId: number,
    configId: number,
    bindId: number
  ): IEndpointData {
    return {
      method: 'DELETE',
      url: `${integrationsUrl}/${integrationId.toString()}/${url}/${specificId.toString()}/configs/${configId.toString()}/bind/${bindId.toString()}`,
    };
  },
});

export default {
  INTEGRATION: {
    ...generateCrudEndpoints(integrationsUrl),
    USER_SEARCH_CONFIG_GET: (id: number) => ({
      method: 'GET',
      url: `${integrationsUrl}/${id}/user-search-config`,
    }),
    USER_SEARCH_CONFIG_SET: (id: number) => ({
      method: 'POST',
      url: `${integrationsUrl}/${id}/user-search-config`,
    }),
    COPY: (id: number): IEndpointData => ({
      method: 'POST',
      url: `${integrationsUrl}/${id.toString()}/copy`
    })
  },
  INTEGRATION_SECTIONS: {
    ...generateCrudEndpoints(`${integrationsUrl}/sections`),
    ARRANGE(id: number): IEndpointData {
      return {
        method: 'PUT',
        url: `${integrationsUrl}/sections/${id.toString()}/arrange`,
      };
    },
    IMPORT_XML: {
      method: 'POST',
      url: `${integrationsUrl}/sections/epgu/generate-fields`,
    },
    VALIDATE_XML: {
      method: 'POST',
      url: `${integrationsUrl}/sections/epgu/validate-fields`,
    },
  },
  INTEGRATION_CONFIG_SERVICE_ROUTE: {
    ...generateIntegrationEndpoints('routes'),
  },
  INTEGRATION_CONFIG_PROFILE_TYPE: {
    ...generateIntegrationEndpoints('profile-types'),
  },
  INTEGRATION_CONFIG_PROJECT_FORM: {
    ...generateIntegrationEndpoints('project-type-forms'),
  },
};
